import { render, staticRenderFns } from "./TeamSBtableDetail.vue?vue&type=template&id=431146d0&scoped=true"
import script from "./TeamSBtableDetail.vue?vue&type=script&lang=js"
export * from "./TeamSBtableDetail.vue?vue&type=script&lang=js"
import style0 from "./TeamSBtableDetail.vue?vue&type=style&index=0&id=431146d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431146d0",
  null
  
)

export default component.exports